var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import { connect } from 'react-redux';
import Loadable from 'react-loadable';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import MainLayout from '../../layouts/MainLayout';
import IconButton from '@material-ui/core/IconButton';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import DownloadIcon from '@material-ui/icons/GetApp';
import { storeCurrentMenuItemPosition, storeCurrentParentMenuItemPosition } from '../../store/header/actions';
import { LoadingDefault } from '../../components/common/loading/loading';
import { InputIcon } from '../../components/common/input/input';
import { Pagination } from '../../components/common/pagination/pagination';
import { formatNumber, notificationSimple } from '../../utils/CommonUtil';
import { exportCSVFromContents } from '../../utils/FileUtil';
import { getReportJob, deleteReportJob } from '../../services/report-service';
import _ from 'lodash';
import './index.scss';
import * as Constant from '../../utils/Constant';
var TableDefault = Loadable({
    loader: function () { return import('../../components/common/table/table'); },
    loading: function () { return React.createElement(LoadingDefault, null); },
    render: function (loaded, props) {
        var ComponentTable = loaded["TableDefault"];
        return React.createElement(ComponentTable, __assign({}, props));
    }
});
var ReportQueue = function (props) {
    var history = useHistory();
    var t = useTranslation().t;
    var _a = useState([]), reportJobAll = _a[0], setReportJobAll = _a[1];
    var _b = useState([]), reportJobList = _b[0], setDataReportJob = _b[1];
    var _c = useState(""), keyword = _c[0], setKeyword = _c[1];
    var _d = useState(""), status = _d[0], setStatus = _d[1];
    var _e = useState([]), accountList = _e[0], setAccounts = _e[1];
    var _f = useState(""), accountSelected = _f[0], setAccountSelected = _f[1];
    var _g = useState(false), isLoading = _g[0], setLoading = _g[1];
    var _h = useState(null), sortByData = _h[0], setSortByData = _h[1];
    var _j = useState({
        offset: 0,
        perPage: 30,
        currentPage: 0,
        pageCount: 0,
        pageSum: 30
    }), paging = _j[0], setPaging = _j[1];
    var _isMounted = useRef(true);
    var isLoadingSync = false;
    var columns = useMemo(function () { return [
        {
            Header: "ID",
            accessor: "id",
            Cell: function (row) { return React.createElement("div", { style: { textAlign: "center" } }, row.value); }
        },
        {
            Header: "Report Name",
            accessor: "dataSettingInfo.reportGroupName",
        },
        {
            Header: "Status",
            accessor: "",
            Cell: function (cell) {
                var _a = cell.row.original, status = _a.status, completedPercent = _a.completedPercent;
                return React.createElement("div", { style: { textAlign: "center" } },
                    status == "IN_QUEUE" ? React.createElement("span", { className: 'text-info' }, "In queue") : null,
                    status == "IN_PROCESSING" ? React.createElement("span", { className: 'text-primary' },
                        "Processing ",
                        completedPercent ? "(" + formatNumber(Number(completedPercent), 2) + "%)" : "") : null,
                    status == "FAILED_PROCESSED" ? React.createElement("span", { className: 'text-danger' },
                        "Failed ",
                        completedPercent ? "(" + formatNumber(Number(completedPercent), 2) + "%)" : "") : null,
                    status == "PROCESSED" ? React.createElement("span", { className: 'text-success' }, "Finished") : null,
                    status == "CREATED" ? React.createElement("span", { className: 'text-info' }, "Created") : null);
            }
        },
        {
            Header: "Created Date",
            accessor: "createdDate",
            Cell: function (row) { return React.createElement("div", { style: { textAlign: "center" } }, row.value ? moment(row.value).format("YYYY/MM/DD HH:mm:ss") : "-"); }
        },
        {
            Header: "" + t("alert.creator"),
            accessor: "creator",
            Cell: function (row) { return React.createElement("div", { style: { textAlign: "center" } }, row.value ? row.value.firstName + " " + row.value.lastName : "-"); }
        },
        {
            Header: "Duration",
            accessor: "",
            Cell: function (cell) {
                var dataSettingInfo = cell.row.original.dataSettingInfo;
                var startDate = dataSettingInfo && dataSettingInfo.fromDate ? moment(dataSettingInfo.fromDate).format("YYYY/MM/DD") : "";
                var endDate = dataSettingInfo && dataSettingInfo.toDate ? moment(dataSettingInfo.toDate).format("YYYY/MM/DD") : "";
                return React.createElement("div", { style: { textAlign: "center" } }, startDate && endDate ? startDate + " -> " + endDate : "");
            }
        },
        {
            Header: "" + t("gam.actions"),
            width: 100,
            minWidth: 100,
            accessor: "",
            Cell: function (cell) { return (React.createElement("div", { className: 'text-center' },
                React.createElement(IconButton, { color: "primary", disabled: !cell.row.original.status || cell.row.original.status != "PROCESSED", onClick: function () { return onDownloadReportJob(cell.row.original.id, cell.row.original.resultFilePath); }, size: "small", classes: { colorPrimary: cell.row.original.status && cell.row.original.status == "PROCESSED" ? "ic-edit-primary" : "ic-edit-default" }, title: "Download", className: "ic-edit", "aria-label": "Download", component: "span" },
                    React.createElement(DownloadIcon, null)),
                React.createElement(IconButton, { color: "inherit", onClick: function () { return deleteReportJobFn(cell.row.values.id); }, size: "small", classes: { colorInherit: "ic-remove" }, title: "Delete", className: "ic-edit", "aria-label": "Delete", component: "span" },
                    React.createElement(DeleteForeverIcon, null)))); }
        }
    ]; }, [reportJobList]);
    useEffect(function () {
        document.title = t("page.report_queue") + Constant.APP_NAME;
        props.dispatch(storeCurrentMenuItemPosition({ position: 1 }));
        props.dispatch(storeCurrentParentMenuItemPosition({ position: 1 }));
        getReportJobData();
        return function () {
            // props.dispatch(resetNetworkInfo());
            _isMounted.current = false;
        };
    }, []);
    var deleteReportJobFn = function (id) {
        if (!confirm("" + t("report.message_delete_report_job"))) {
            return;
        }
        callAPIDeleteReportJob(id);
    };
    var callAPIDeleteReportJob = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var data, foundIndexReportJob, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, deleteReportJob(id)];
                case 1:
                    _a.sent();
                    if (id) {
                        data = reportJobList && reportJobList.length ? _.cloneDeep(reportJobList) : [];
                        foundIndexReportJob = data.findIndex(function (reportJob) { return reportJob.id == id; });
                        if (foundIndexReportJob > -1) {
                            data.splice(foundIndexReportJob, 1);
                        }
                        setDataReportJob(data);
                        notificationSimple("Delete Report Queue Success!", Constant.NOTIFICATION_SUCCESS);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.log("Delete Report Job Error");
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onDownloadReportJob = function (id, path) { return __awaiter(void 0, void 0, void 0, function () {
        var fileNameReportJob;
        return __generator(this, function (_a) {
            if (!path)
                return [2 /*return*/];
            fileNameReportJob = 'report_job_' + id;
            exportCSVFromContents(fileNameReportJob, path, "URL");
            notificationSimple('Download Report Queue success.', Constant.NOTIFICATION_SUCCESS);
            return [2 /*return*/];
        });
    }); };
    var getReportJobData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, reportJobs, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getReportJob({})];
                case 2:
                    result = _a.sent();
                    reportJobs = _.sortBy((result || []), function (option) { return -option.id; });
                    handleGetData(reportJobs || [], paging, status, keyword, sortByData);
                    setReportJobAll(reportJobs);
                    setLoading(false);
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    setLoading(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleGetData = function (data, paging, status, keyword, sortBys) {
        var dataNetwork = _.cloneDeep(data);
        var offset = paging.offset, perPage = paging.perPage, currentPage = paging.currentPage;
        var listNetwork = dataNetwork.filter(function (item) {
            var reportGroupName = item.dataSettingInfo && item.dataSettingInfo.reportGroupName ? item.dataSettingInfo.reportGroupName : "";
            return (!keyword ||
                (reportGroupName || '').toLowerCase().indexOf((keyword || '').toLowerCase()) !== -1) &&
                //status
                (!status ||
                    (status == item.status));
        });
        if (sortBys && sortBys.length && sortBys[0].id) {
            listNetwork = _.sortBy(listNetwork || [], function (option) {
                return sortBys[0].desc ? -option[sortBys[0].id] : option[sortBys[0].id];
            });
        }
        else {
            listNetwork = _.sortBy(listNetwork || [], function (option) { return -option.id; });
        }
        var pageList = listNetwork.slice(offset, offset + perPage);
        paging.pageSum = listNetwork.length;
        paging.pageCount = Math.ceil(listNetwork.length / paging.perPage);
        setPaging(paging);
        setDataReportJob(pageList);
    };
    var onChangeSearch = function (event) {
        event.preventDefault();
        setKeyword(event.currentTarget.value);
        handleGetData(reportJobAll, paging, status, event.currentTarget.value, sortByData);
    };
    var onChangeStatus = function (event) {
        event.preventDefault();
        setStatus(event.currentTarget.value);
        handleGetData(reportJobAll, paging, event.currentTarget.value, keyword, sortByData);
    };
    var handlePageClick = function (e) {
        var selectedPage = e.selected;
        var perPage = paging.perPage;
        var offset = selectedPage * perPage;
        paging.currentPage = selectedPage;
        paging.offset = offset;
        setPaging(paging);
        handleGetData(reportJobAll, paging, status, keyword, sortByData);
    };
    var handlePaperSelect = function (event) {
        var currentPage = paging.currentPage;
        paging.perPage = parseInt(event.currentTarget.value);
        var offset = currentPage * paging.perPage;
        paging.offset = offset;
        setPaging(paging);
        handleGetData(reportJobAll, paging, status, keyword, sortByData);
    };
    var onChangeSort = function (sortBy) {
        if (sortBy && sortBy.length) {
            setSortByData(sortBy);
            handleGetData(reportJobAll, paging, status, keyword, sortBy);
        }
    };
    return (React.createElement(MainLayout, null,
        React.createElement("div", { className: "layout-static" },
            React.createElement("div", { className: "static-content-wrapper" },
                React.createElement("div", { className: "static-content" },
                    React.createElement("div", { className: "page-content page-publishers" },
                        React.createElement("div", { className: "container-fluid container-alert" },
                            React.createElement("div", { className: "panel alert-list-container" },
                                React.createElement("div", { className: "panel-heading" },
                                    React.createElement(Grid, { container: true, direction: "row", justify: "space-between", alignItems: "center", className: "" },
                                        React.createElement("div", null,
                                            React.createElement(InputIcon, { type: "text", value: keyword, onChange: onChangeSearch, iconName: "search", placeholder: t("common.search_by_report_name") })),
                                        React.createElement("div", null,
                                            React.createElement(Grid, { container: true, direction: "row", justify: "center", alignItems: "center", alignContent: "center", spacing: 1 },
                                                React.createElement(Grid, { item: true, className: "select-status filter-line-item" },
                                                    React.createElement("select", { className: "form-control btn", value: status, onChange: onChangeStatus },
                                                        React.createElement("option", { value: "" }, "Filter By Status"),
                                                        React.createElement("option", { value: "CREATED" }, "Created"),
                                                        React.createElement("option", { value: "IN_QUEUE" }, "In queue"),
                                                        React.createElement("option", { value: "IN_PROCESSING" }, "Processing"),
                                                        React.createElement("option", { value: "FAILED_PROCESSED" }, "Failed"),
                                                        React.createElement("option", { value: "PROCESSED" }, "Finished"))))))),
                                React.createElement("div", { className: "panel-body" },
                                    React.createElement("div", { className: "table-container" },
                                        React.createElement(TableDefault, { columns: columns, data: reportJobList, loading: isLoading, onChangeSort: onChangeSort, isManualSort: true }))),
                                reportJobAll && reportJobAll.length ? React.createElement("div", { className: "panel-footer" },
                                    React.createElement(Pagination, { handlePageClick: handlePageClick, pagePer: paging.perPage, pageCount: paging.pageCount, pageNumber: paging.currentPage, offset: paging.offset, pageSumLength: paging.pageSum, pageLength: reportJobList.length, handlePaperSelect: handlePaperSelect })) : null))))))));
};
function mapStateToProps(state) {
    return {};
}
export default connect(mapStateToProps)(ReportQueue);
